module.exports = __webpack_public_path__ + "static/hero-image-9e6a1af6b961d4acef31aa068734f1df.png";